import React from 'react'
import { Form } from 'semantic-ui-react'

export default class PhoneField extends React.PureComponent {
  render() {
    const { value, onChange, disabled } = this.props

    return (
      <Form.Input
        fluid
        label="Phone"
        disabled={disabled}
        required
        placeholder="e.g +855xxxxxxxx"
        onChange={e => onChange('tel', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/phoneField.js